<template>
  <div class="home">
    <h2>Closure List</h2>
    <select v-model="currSort">
      <option value="location">Location</option>
      <option value="closing_type">Closure Type</option>
      <option value="closing_date">Closure Date</option>
      <option value="opening_date">Re-Opening Date</option>
    </select>
    <closure-table :data="closures" :fields="showFields" :singleView="false"></closure-table>
    <!-- <p v-for="(closure, index) in closures" :key="index">
      <a :href="`details/${closure.id}`"> {{ closure.location }} </a>
    </p> -->
    
  </div>
</template>

<script>
// @ is an alias to /src
import ClosureTable from '@/components/ClosureTable.vue'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    ClosureTable
  },
  data: function () {
    return {
      closures: {},
      showFields: {},
      mapConfigReady: false,
      mapConfig: {},
      siteConfig: {},
      checkedLayers: ['routesLayer'],
      currSort: "location"
    }
  },
  methods: {
    doSort: function () {
      if (this.closures.sort)
        this.closures.sort(this.stringSort)
    },
    stringSort: function (a, b) {
			var x = a[this.currSort].toLowerCase();
			var y = b[this.currSort].toLowerCase();

			if (x < y) { return -1; }
			if (x > y) { return 1; }
			return 0;
		}
  },
  created: async function () {
    let siteConfig = await axios.get('site.json');
    this.siteConfig = siteConfig.data;
    this.showFields = this.siteConfig.showFields;
    
    let closures = await axios.get(`${this.siteConfig.opendataService.url}${this.siteConfig.closureDataset.query}`);
    this.closures = closures.data;
    this.$emit('data-loaded', this.closures);
    this.doSort();
  },
  watch: {
    currSort: "doSort"
  }
}
</script>